<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">Thiosulfate ion is oxidized by iodine according to the following reaction:</p>
      <p class="mb-2">
        <chemical-latex content="2S2O3^{2-}(aq) + I2(aq) → S4O6^{2-}(aq) + 2I-(aq)" />
      </p>
      <p class="mb-3">
        When the reaction comes to a steady state,
        <number-value :value="moles" unit="\text{mol}" /> of
        <chemical-latex content="S2O3^{2-}(aq)" /> are consumed in 1.00 L of solution each second.
        Under these steady state conditions, how many moles of iodide would be produced each second?
      </p>

      <calculation-input
        v-model="inputs.rate"
        prepend-text="$\text{Rate:}$"
        append-text="$\text{mol/s}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'ChemSIU131_Task15',
  components: {
    ChemicalLatex,
    CalculationInput,
    NumberValue,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        rate: null,
      },
    };
  },
  computed: {
    moles() {
      return this.taskState.getValueBySymbol('moles').content;
    },
  },
};
</script>
